// extracted by mini-css-extract-plugin
export default {"wrapper":"CreateOrganizationPopupFormStep1_wrapper__qGaGx"};